import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

// --- Constants ---

const COMPONENT_UID_KEY = '_uid'

export { COMPONENT_UID_KEY, Vue, mergeData }
